import React, { memo } from 'react'
import VariantRow from './VariantRow'
import { IDropdownModel, IUnlimitedBanner } from '../types'

interface IProps {
  models: IDropdownModel[]
  selectedKey: string | null
  onSelect: (model: IDropdownModel) => void
  unlimitedBanner?: IUnlimitedBanner
}

const VariantList: React.FC<IProps> = ({
  models,
  selectedKey,
  onSelect,
  unlimitedBanner
}) => (
  <>
    {models.map(model => (
      <VariantRow
        key={model.selectKey}
        model={model}
        isSelected={model.selectKey === selectedKey}
        onSelect={() => onSelect(model)}
        unlimitedBanner={unlimitedBanner}
      />
    ))}
  </>
)

export default memo(VariantList)
